import React, { useEffect, useState } from 'react';
import './Trending.css';
import Marquee from 'react-fast-marquee';
import UnlistedLogo from '../../assets/unlisted-logo.png';

interface Token {
  name: string;
  symbol: string;
  logo: string;
  chain: string;
  contract: string;
  change24: string;
}

const Trending: React.FC = () => {
  const [data, setData] = useState<Token[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          'https://trendingbar-coinsultinfo.replit.app/trending'
        );
        if (!res.ok) throw new Error('Network response was not ok');
        const json = await res.json();
        setData(json.projects || []);
      } catch (err: any) {
        console.error(err.message);
      }
    };
    fetchData();
  }, []);

  if (data.length === 0) return null;

  // Duplicate the list for a continuous marquee
  const items = [...data, ...data];

  return (
    <div className="trending-bar">
      <Marquee pauseOnHover speed={60}>
        {items.map((item, idx) => {
          const changeValue = parseFloat(item.change24);
          const changeClass = changeValue > 0 ? 'positive' : changeValue === 0 ? 'neutral' : 'negative';

          return (
            <a
              key={`${item.contract}-${idx}`}
              href={`/${item.chain}/${item.contract}`}
              className="trending-item"
            >
              <span className="trending-rank">#{(idx % data.length) + 1}</span>
              <img
                src={item.logo || UnlistedLogo}
                alt={item.symbol}
                className="trending-logo"
              />
              <span className="trending-symbol">{item.symbol}</span>
              <span className={`trending-change24 ${changeClass}`}>{item.change24}%</span>
            </a>
          );
        })}
      </Marquee>
    </div>
  );
};

export default Trending;
